import { Tool } from '@/types';

export const tools: Tool[] = [
  // PDF Tools
  {
    id: 'pdf-to-jpg',
    name: 'PDF to JPG Converter',
    description: 'Convert PDF pages to high-quality JPG images online for free. Fast and secure PDF to JPEG conversion.',
    icon: 'FileImage',
    type: 'pdf',
    slug: 'pdf-to-jpg',
    category: 'PDF',
    popular: true,
  },
  {
    id: 'pdf-to-png',
    name: 'PDF to PNG Converter',
    description: 'Convert PDF pages to PNG images with transparency support. Free online PDF to PNG converter tool.',
    icon: 'FileImage',
    type: 'pdf',
    slug: 'pdf-to-png',
    category: 'PDF',
  },
  {
    id: 'merge-pdf',
    name: 'Merge PDF Files Online',
    description: 'Combine multiple PDF files into one single document. Free PDF merger tool - fast and secure.',
    icon: 'Files',
    type: 'pdf',
    slug: 'merge-pdf',
    category: 'PDF',
    popular: true,
  },
  {
    id: 'split-pdf',
    name: 'Split PDF Pages Online',
    description: 'Separate one PDF file into multiple files or extract specific pages. Free PDF splitter tool.',
    icon: 'Scissors',
    type: 'pdf',
    slug: 'split-pdf',
    category: 'PDF',
  },
  {
    id: 'compress-pdf',
    name: 'Compress PDF File Size',
    description: 'Reduce PDF file size while maintaining quality. Free online PDF compressor - optimize PDFs instantly.',
    icon: 'Minimize2',
    type: 'pdf',
    slug: 'compress-pdf',
    category: 'PDF',
    popular: true,
  },
  {
    id: 'jpg-to-pdf',
    name: 'JPG to PDF Converter',
    description: 'Convert JPG images to a single PDF document. Free online JPEG to PDF converter tool.',
    icon: 'FileText',
    type: 'pdf',
    slug: 'jpg-to-pdf',
    category: 'PDF',
  },
  {
    id: 'word-to-pdf',
    name: 'Word to PDF Converter',
    description: 'Convert Word documents (DOC, DOCX) to PDF online. Free DOCX to PDF converter - no software needed.',
    icon: 'FileType2',
    type: 'pdf',
    slug: 'word-to-pdf',
    category: 'PDF',
  },
  {
    id: 'pdf-to-word',
    name: 'PDF to Word Converter',
    description: 'Convert PDF documents to editable Word files (DOCX). Free online PDF to DOC converter.',
    icon: 'FileType2',
    type: 'pdf',
    slug: 'pdf-to-word',
    category: 'PDF',
  },
  {
    id: 'pdf-to-excel',
    name: 'PDF to Excel Converter',
    description: 'Extract tables and data from PDF to Excel spreadsheet. Free PDF to XLS/XLSX converter online.',
    icon: 'FileSpreadsheet',
    type: 'pdf',
    slug: 'pdf-to-excel',
    category: 'PDF',
  },
  {
    id: 'excel-to-pdf',
    name: 'Excel to PDF Converter',
    description: 'Convert Excel spreadsheets (XLS, XLSX) to PDF documents online. Free and secure conversion.',
    icon: 'FileSpreadsheet',
    type: 'pdf',
    slug: 'excel-to-pdf',
    category: 'PDF',
  },
  {
    id: 'pdf-to-powerpoint',
    name: 'PDF to PowerPoint Converter',
    description: 'Convert PDF pages to PowerPoint presentation slides (PPT, PPTX). Free online PDF to PPT tool.',
    icon: 'Presentation',
    type: 'pdf',
    slug: 'pdf-to-powerpoint',
    category: 'PDF',
  },
  {
    id: 'rotate-pdf',
    name: 'Rotate PDF Pages Online',
    description: 'Rotate PDF pages by 90, 180, or 270 degrees. Free PDF rotation tool - adjust page orientation.',
    icon: 'RotateCw',
    type: 'pdf',
    slug: 'rotate-pdf',
    category: 'PDF',
  },
  {
    id: 'add-watermark',
    name: 'Add Watermark to PDF',
    description: 'Protect your PDF documents by adding custom text watermarks online. Free PDF watermark tool.',
    icon: 'Type',
    type: 'pdf',
    slug: 'add-watermark',
    category: 'PDF',
  },
  {
    id: 'edit-pdf',
    name: 'Edit PDF Online Free',
    description: 'Add text, shapes, and annotations to PDF files online. Free PDF editor with drawing tools.',
    icon: 'Edit',
    type: 'pdf',
    slug: 'pdf-to-edit',
    category: 'PDF',
    popular: true,
  },
  {
    id: 'sign-pdf',
    name: 'Sign PDF Electronically',
    description: 'Add your electronic signature to PDF documents online. Free digital signature tool for PDFs.',
    icon: 'PenTool',
    type: 'pdf',
    slug: 'sign-pdf',
    category: 'PDF',
  },

  // Image Tools
  {
    id: 'image-resizer',
    name: 'Image Resizer Online Free',
    description: 'Resize images to specific dimensions or percentage online. Free image resizing tool for JPG, PNG, WebP.',
    icon: 'Scaling',
    type: 'image',
    slug: 'image-resizer',
    category: 'Image',
    popular: true,
  },
  {
    id: 'image-compressor',
    name: 'Image Compressor Online',
    description: 'Compress JPG, PNG, WEBP images without losing quality. Free online image compression tool.',
    icon: 'Minimize',
    type: 'image',
    slug: 'image-compressor',
    category: 'Image',
    popular: true,
  },
  {
    id: 'image-cropper',
    name: 'Crop Image Online Free',
    description: 'Crop images to remove unwanted parts. Free online image cropping tool for photos.',
    icon: 'Crop',
    type: 'image',
    slug: 'image-cropper',
    category: 'Image',
  },
  {
    id: 'jpg-to-png',
    name: 'JPG to PNG Converter',
    description: 'Convert JPG images to PNG format online. Free JPEG to PNG converter with transparency.',
    icon: 'Image',
    type: 'image',
    slug: 'jpg-to-png',
    category: 'Image',
  },
  {
    id: 'png-to-jpg',
    name: 'PNG to JPG Converter',
    description: 'Convert PNG images to JPG format online. Free PNG to JPEG converter tool.',
    icon: 'Image',
    type: 'image',
    slug: 'png-to-jpg',
    category: 'Image',
  },
  {
    id: 'webp-to-jpg',
    name: 'WebP to JPG Converter',
    description: 'Convert WebP images to standard JPG format online. Free WebP to JPEG converter.',
    icon: 'Image',
    type: 'image',
    slug: 'webp-to-jpg',
    category: 'Image',
  },
  {
    id: 'webp-to-png',
    name: 'WebP to PNG Converter',
    description: 'Convert WebP images to transparent PNG format online. Free WebP converter tool.',
    icon: 'Image',
    type: 'image',
    slug: 'webp-to-png',
    category: 'Image',
  },
  {
    id: 'png-to-webp',
    name: 'PNG to WebP Converter',
    description: 'Convert PNG images to modern WebP format online. Free PNG to WebP converter for web optimization.',
    icon: 'Image',
    type: 'image',
    slug: 'png-to-webp',
    category: 'Image',
  },
  {
    id: 'jpg-to-webp',
    name: 'JPG to WebP Converter',
    description: 'Convert JPG images to modern WebP format online. Free JPEG to WebP converter tool.',
    icon: 'Image',
    type: 'image',
    slug: 'jpg-to-webp',
    category: 'Image',
  },
  {
    id: 'image-converter',
    name: 'Image Format Converter',
    description: 'Convert images between various formats (JPG, PNG, WebP). Free online image converter tool.',
    icon: 'RefreshCw',
    type: 'image',
    slug: 'image-converter',
    category: 'Image',
  },
  {
    id: 'remove-background',
    name: 'Remove Background from Image',
    description: 'Remove background from images automatically online. Free AI background remover tool.',
    icon: 'Eraser',
    type: 'image',
    slug: 'remove-background',
    category: 'Image',
    popular: true,
  },

  {
    id: 'image-to-vector',
    name: 'Image to Vector (SVG)',
    description: 'Convert raster images (JPG, PNG) to scalable SVG vectors.',
    icon: 'Vector',
    type: 'image',
    slug: 'image-to-vector',
    category: 'Image',
    popular: true,
  },

  // Text Tools
  {
    id: 'word-counter',
    name: 'Word Counter',
    description: 'Count words, characters, and lines in your text.',
    icon: 'Type',
    type: 'text',
    slug: 'word-counter',
    category: 'Text',
    popular: true,
  },
  {
    id: 'case-converter',
    name: 'Case Converter',
    description: 'Convert text to uppercase, lowercase, title case, etc.',
    icon: 'CaseSensitive',
    type: 'text',
    slug: 'case-converter',
    category: 'Text',
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem Ipsum Generator',
    description: 'Generate placeholder text for your designs.',
    icon: 'AlignLeft',
    type: 'text',
    slug: 'lorem-ipsum',
    category: 'Text',
  },
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Beautify and validate JSON data.',
    icon: 'Braces',
    type: 'text',
    slug: 'json-formatter',
    category: 'Text',
    popular: true,
  },
  {
    id: 'diff-checker',
    name: 'Diff Checker',
    description: 'Compare two text files to find differences.',
    icon: 'GitCompare',
    type: 'text',
    slug: 'diff-checker',
    category: 'Text',
  },
  {
    id: 'markdown-editor',
    name: 'Markdown Editor',
    description: 'Write and preview Markdown content.',
    icon: 'FileCode',
    type: 'text',
    slug: 'markdown-editor',
    category: 'Text',
  },

  // Dev & Other Tools
  {
    id: 'qr-generator',
    name: 'QR Code Generator',
    description: 'Create QR codes for URLs, text, and more.',
    icon: 'QrCode',
    type: 'dev',
    slug: 'qr-generator',
    category: 'Other',
    popular: true,
  },
  {
    id: 'password-generator',
    name: 'Password Generator',
    description: 'Generate strong and secure passwords.',
    icon: 'Key',
    type: 'dev',
    slug: 'password-generator',
    category: 'Other',
  },
  {
    id: 'base64-encode',
    name: 'Base64 Encoder',
    description: 'Encode text or files to Base64 format.',
    icon: 'Code',
    type: 'dev',
    slug: 'base64-encode',
    category: 'Dev',
  },
  {
    id: 'base64-decode',
    name: 'Base64 Decoder',
    description: 'Decode Base64 strings back to text.',
    icon: 'Code',
    type: 'dev',
    slug: 'base64-decode',
    category: 'Dev',
  },
  {
    id: 'color-picker',
    name: 'Color Picker',
    description: 'Pick colors and get Hex, RGB, HSL codes.',
    icon: 'Palette',
    type: 'dev',
    slug: 'color-picker',
    category: 'Dev',
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder',
    description: 'Encode text to URL-safe format.',
    icon: 'Link',
    type: 'dev',
    slug: 'url-encoder',
    category: 'Dev',
  },
  {
    id: 'url-decoder',
    name: 'URL Decoder',
    description: 'Decode URL-encoded strings.',
    icon: 'Link2',
    type: 'dev',
    slug: 'url-decoder',
    category: 'Dev',
  },
  {
    id: 'uuid-generator',
    name: 'UUID Generator',
    description: 'Generate unique UUID v4 identifiers.',
    icon: 'Fingerprint',
    type: 'dev',
    slug: 'uuid-generator',
    category: 'Dev',
  },
];

export const categories = [
  { id: 'all', name: 'All Tools', description: 'Browse all available tools' },
  { id: 'pdf', name: 'PDF Tools', description: 'Manage and convert PDF files' },
  { id: 'image', name: 'Image Tools', description: 'Edit and convert images' },
  { id: 'text', name: 'Text Tools', description: 'Text manipulation utilities' },
  { id: 'dev', name: 'Developer Tools', description: 'Utilities for developers' },
];
